import Link from "next/link"
import { safeHref } from "@/lib/safe-href"

type CTAData = {
  heading?: string
  subheading?: string
  button_label?: string
  button_url?: string
  style?: "dark" | "light" | "accent"
}

export function CTASection({ data }: { data: CTAData }) {
  const style = data.style ?? "dark"

  const sectionClass =
    style === "dark"
      ? "bg-gradient-to-br from-[var(--cta-background)] via-[var(--primary)] to-[var(--primary-dark)] text-white"
      : style === "light"
        ? "bg-[var(--background)] border-t border-[var(--border)] text-[var(--primary)]"
        : "bg-[var(--accent)] text-[var(--accent-foreground)]"

  const headingClass =
    style === "dark" ? "text-white" : "text-[var(--primary)]"

  const subClass =
    style === "dark" ? "text-[var(--hero-subtitle)]" : "text-[var(--muted-foreground)]"

  const btnClass =
    style === "dark"
      ? "bg-[var(--accent)] text-[var(--accent-foreground)] hover:bg-white"
      : style === "light"
        ? "bg-[var(--accent)] text-[var(--accent-foreground)] hover:bg-[var(--primary)] hover:text-white"
        : "bg-[var(--primary)] text-white hover:bg-[var(--primary-darker)]"

  return (
    <section className={`${sectionClass} px-4 py-16 md:py-24`}>
      <div className="mx-auto max-w-3xl text-center">
        {data.heading && (
          <h2 className={`text-3xl font-bold ${headingClass}`}>
            {data.heading}
          </h2>
        )}
        {data.subheading && (
          <p className={`mt-4 text-pretty ${subClass}`}>{data.subheading}</p>
        )}
        {data.button_label && data.button_url && (
          <Link
            href={safeHref(data.button_url)}
            className={`mt-8 inline-flex min-h-11 items-center justify-center rounded-lg px-8 py-3 text-sm font-bold shadow-md transition ${btnClass}`}
          >
            {data.button_label}
          </Link>
        )}
      </div>
    </section>
  )
}
